import { SynthAddressBook } from '@arcxgame/contracts/dist/arc-types/core'
import { getAddressesForNetwork } from './getAddressesForNetwork'
import { getConfigForNetwork } from './getConfigForNetwork'
import { Network } from './Network'

export function getSpritzAddresses(network: Network, isPlaynetActive: boolean): SynthAddressBook {
  const allAddresses = getAddressesForNetwork(network)
  const spritzConfigs = getConfigForNetwork(network, isPlaynetActive).spritzConfigs

  return {
    proxy: getAddress(allAddresses, spritzConfigs.proxy.group, spritzConfigs.proxy.name),
    syntheticToken: getAddress(
      allAddresses,
      spritzConfigs.syntheticToken.group,
      spritzConfigs.syntheticToken.name,
    ),
    collateralAsset: getAddress(
      allAddresses,
      spritzConfigs.collateralAsset.group,
      spritzConfigs.collateralAsset.name,
    ),
    oracle: getAddress(allAddresses, spritzConfigs.oracle.group, spritzConfigs.oracle.name),
    state: getAddress(allAddresses, spritzConfigs.state.group, spritzConfigs.state.name),
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getAddress(deployments: any[], group: string, name: string) {
  return deployments.find((deployment) => deployment.group === group && deployment.name === name)
    ?.address
}
